<template>
  <!-- <div>{{taskDetail.id}}</div> -->
  <material-card v-if="taskDetail.id" title="Tarefa" text>
    <v-card-title>
      <span class="headline">{{
        taskDetail.departament_id.toUpperCase()
      }}</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 sm12 md12>
            <v-textarea
              v-model="taskDetail.content"
              label="Descrição"
              readonly
            ></v-textarea>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              prepend-inner-icon="flag"
              v-model="taskDetail.priority"
              label="Criticidade"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              prepend-inner-icon="supervised_user_circle"
              v-model="taskDetail.departament_id"
              label="Departamento"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              prepend-inner-icon="person"
              v-model="taskDetail.responsible_name"
              label="Consultor"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              prepend-inner-icon="event"
              v-model="taskDetail.due"
              label="Vence em"
              readonly
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md12>
            <span>Comentários</span>
            <v-list three-line>
              {{ taskDetail.comments.length }}
              <template v-for="(item, index) in taskDetail.comments">
                <v-list-tile :key="item.id" avatar ripple>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      item.created_by_name
                    }}</v-list-tile-title>
                    <span
                      v-html="item.content"
                      class="grey--text body-1"
                    ></span>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-list-tile-action-text>{{
                      item.created_at | formatarDate
                    }}</v-list-tile-action-text>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < taskDetail.comments.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <span>Adicionar Comentário</span>
            <v-textarea
              box
              name="comment-content"
              v-model="commentContent"
              value
              placeholder="Comece a digitar para adicionar um comentário..."
              hint="Mínimo de 15 caracteres"
              required
            ></v-textarea>
            <v-btn color="blue darken-1" @click="createComment()"
              >Adicionar</v-btn
            >
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              prepend-inner-icon="bookmark"
              v-model="taskDetail.status"
              label="Status atual"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-select
              prepend-inner-icon="bookmark_border"
              :items="statuses"
              v-model="status"
              item-text="text"
              item-value="id"
              label="Mudar status"
              required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4>
            <v-btn color="blue darken-1" @click="changeStatus()">Alterar</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </material-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
// import {addCommentInTask} from "../../../services/support/tasks"
export default {
  data() {
    return {
      commentContent: "",
      status: "",
      statuses: [
        { text: "Aberto", id: "open" },
        { text: "Em atendimento", id: "in_attendance" },
        { text: "Aguardando membro", id: "waiting_customer" },
        { text: "Fechada", id: "closed" },
      ],
      taskDetail: {},
    };
  },
  computed: {
    ...mapState("cs", ["task"]),
    ...mapState(["user"]),
  },
  watch: {
    task(val) {
      // console.log('val', val)
      if (val) {
        this.taskDetail = val;
        this.commentContent = "";
        this.status = "";
      }
    },
  },
  methods: {
    ...mapActions("cs", ["addCommentInTask", "updateTaskStatus"]),
    async createComment() {
      // console.log("taskId: ", this.taskDetail.id)
      // console.log("description: ", this.commentContent)
      await this.addCommentInTask({
        task: this.taskDetail,
        content: this.commentContent,
        created_by_id: this.user.id,
        created_by_name: this.user.name,
      });
      this.commentContent = "";
    },
    async changeStatus() {
      // console.log("old status", this.taskDetail.status)
      // console.log("new status", this.status)
      await this.updateTaskStatus({
        task: this.taskDetail,
        status: this.status,
      });
    },
  },
};
</script>
